import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, Navigate } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { HeaderProfile, ProfileMenu } from '../../components/profile-prive'

import { WEBROOT, APP_NAME } from '../../constants/general'

import { Context } from '../../class/Context'

import Func from '../../class/Func'

import Paiements_Class from '../../class/Paiements_Class'

function PasserOwnerValidation() {

    const navigate = useNavigate();

    const context = useContext(Context)

    const [flash, setFlash] = useState('')

    const [data, setData] = useState(false)

    const [loading, setLoading] = useState(false)

    const userPaiements = async () => {

        let results = await Paiements_Class.paiements()

        console.log(results)

        if (results.success) {

            setData(results.data)

            // if (results.data.payer_type == 'OWNER') {

            //     Func.setFlash('Tu peux désormais publier des annonces et vendre des plantes ou proposer tes services', 'succes')

            //     navigate('/mon-profile/porte-monnaie')

            //     return false

            // }

        } else {

            setFlash({ message: results.message, type: "error" })

        }

        window.scrollTo(0, 0)

    }

    const sendData = async (e) => {

        e.preventDefault()

        setLoading(true)

        let inputs = e.target

        let date = inputs.date.value

        let results = await Paiements_Class.post('passer-owner', { date })

        console.log(results)

        if (results.success) {

            const redirectUrl = results.RedirectUrl

            const returnUrl = WEBROOT + 'mon-profile/passer-owner-validation'

            // Encoder l'URL de retour
            const encodedReturnUrl = encodeURIComponent(returnUrl);

            // Construire l'URL finale
            const finalUrl = `${redirectUrl}&returnUrl=${encodedReturnUrl}`;

            // Rediriger l'utilisateur
            window.location.href = finalUrl;

            setFlash({ message: results.message, type: "succes" })

        } else {

            setFlash({ message: results.message, type: "error" })

        }

        window.scrollTo(0, 0)

        setLoading(false)

    }

    useEffect(() => {

        Func.session(context, navigate)

        Func.getFlash(setFlash)

        userPaiements()

        document.title = "Passer Owner Validation - " + APP_NAME

    }, [])

    return (

        <div>

            <Header />

            <div className="profil">

                <HeaderBox />

                <div className='content pos-r'>

                    <div className="c">

                        <HeaderProfile />

                    </div>

                    <div className="mt30">

                        <div className="c pos-r">

                            <ProfileMenu data="porte-monnaie" />

                            {(flash !== '') && <p className={flash.type}>{flash.message}</p>}

                            {

                                data == false

                                    ?

                                    <div className='flex jc-center mt50 mb50'>
                                        <div className="lds-dual-ring col"></div>
                                    </div>

                                    :

                                    <p className='succes'>Tu peux désormais publier des annonces et proposer un plant-sitting</p>

                            }

                        </div>
                    </div>
                </div>

            </div>

            <Footer />

        </div>

    )

}

export default PasserOwnerValidation